import * as React from 'react';
type IconProProps = React.SVGProps<SVGSVGElement>;

export const IconPro: React.FC<IconProProps> = (props) => (
	<svg
		width="18"
		height="15"
		viewBox="0 0 18 15"
		fill="white"
		xmlns="http://www.w3.org/2000/svg"
		{...props}>
		<path d="M9.88802 2.8125C10.2344 2.59375 10.4653 2.19688 10.4653 1.75C10.4653 1.05938 9.92144 0.5 9.25 0.5C8.57856 0.5 8.03472 1.05938 8.03472 1.75C8.03472 2.2 8.26562 2.59375 8.61198 2.8125L6.87109 6.39375C6.59462 6.9625 5.8776 7.125 5.39453 6.72813L2.6875 4.5C2.83941 4.29063 2.93056 4.03125 2.93056 3.75C2.93056 3.05937 2.38672 2.5 1.71528 2.5C1.04384 2.5 0.5 3.05937 0.5 3.75C0.5 4.44062 1.04384 5 1.71528 5C1.72135 5 1.73047 5 1.73655 5L3.125 12.8563C3.2921 13.8063 4.09722 14.5 5.03906 14.5H13.4609C14.3997 14.5 15.2049 13.8094 15.375 12.8563L16.7635 5C16.7695 5 16.7786 5 16.7847 5C17.4562 5 18 4.44062 18 3.75C18 3.05937 17.4562 2.5 16.7847 2.5C16.1133 2.5 15.5694 3.05937 15.5694 3.75C15.5694 4.03125 15.6606 4.29063 15.8125 4.5L13.1055 6.72813C12.6224 7.125 11.9054 6.9625 11.6289 6.39375L9.88802 2.8125Z" />
	</svg>
);
export default IconPro;
